import React, { Component } from "react";
import messages from "./TimelineEventFormUpdate.messages";
import {
  Grid,
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Modal,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import TimePicker from "rc-time-picker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import "../forms.css";

import type { CreateProjectParamsObject } from "../../../redux/projects/types";
import Project from "../../../models/Project";
import User from "../../../models/User";
import TimelineEvent from "../../../models/TimelineEvent";
import TimeInput from "../TimeInput";
import GradientButton from "../../../components/input/GradientButton";

type Props = {
  event: TimelineEvent,
  projectId: string,
  projectDate: string,
  user: User,
  updateTimelineEvent: (params: UpdateTimelineEventObject) => Promise<void>,
  onDidUpdateTimelineEvent: (projectId: string) => void,
  onRequestBack: () => void,
  onModalClose: () => void,
};

type State = {
  name: string,
  dateTime: string,
  date: string,
  time: string,
  dateMoment: Object,
  location: string,
  details: string,
  isCustom: boolean,
};

const DATE_FORMAT = "MM-DD-YYYY";
const TIME_FORMAT = "h:mm a";
const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;

export default class TimelineEventFormUpdate extends Component {
  props: Props;

  state: State = {
    name: this.props.event.name,
    dateTime: this.props.event.timezonelessDateTime(),
    date: moment.utc(this.props.event.dateTime).format(DATE_FORMAT),
    time: moment.utc(this.props.event.dateTime).format(TIME_FORMAT),
    dateMoment: moment.utc(this.props.event.dateTime),
    location: this.props.event.location,
    details: this.props.event.details,
  };

  dateRef: TextInput;
  timeRef: TextInput;
  detailsRef: TextInput;
  locationRef: TextInput;

  constructor(props: Props) {
    super(props);
  }

  handleNameChange = (event) => {
    this.setState({ name: event.target.value });
  };

  handleLocationChange = (event) => {
    this.setState({ location: event.target.value });
  };

  handleTimeChange(dateTime) {
    if (dateTime) {
      this.setState({
        dateTime: moment.utc(dateTime).format(),
        date: moment.utc(dateTime).format(DATE_FORMAT),
        dateMoment: moment.utc(dateTime),
      });
    }
  }

  handleDateChange(date) {
    if (date) {
      this.setState({
        dateTime: moment.utc(date).format(),
        date: moment.utc(date).format(DATE_FORMAT),
        dateMoment: moment.utc(date),
      });
    }
  }

  handleNotesChange = (event) => {
    this.setState({ details: event.target.value });
  };

  handleUpdateEvent = (event) => {
    event.preventDefault();
    this.updateEventPromise = Promise.resolve(this.updateEvent());
  };

  async updateEvent() {
    if (!this.state.date) {
      return;
    }
    const event = await this.props.updateTimelineEvent({
      ...this.props.event.toJS(),
      dateTime: this.timezonelessDateTime(),
      name: this.state.name,
      location: this.state.location,
      details: this.state.details,
    });
    this.props.onDidUpdateTimelineEvent();
  }

  timezonelessDateTime(): string {
    return moment.utc(this.state.dateTime).utcOffset(0, true).format();
  }

  // NOTE: is this method used ever?
  formatEventDate(event: TimelineEvent): string {
    const dateTimeFormat = moment(event.dateTime);
    return dateTimeFormat.format(DATE_TIME_FORMAT);
  }

  render() {
    return (
      <div>
        <form onSubmit={this.handleCreateEvent}>
          <Modal.Body>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>{messages.name}</ControlLabel>
                  <FormControl
                    type="text"
                    name={messages.name}
                    placeholder={messages.name}
                    value={this.state.name}
                    onChange={this.handleNameChange}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>{messages.location}</ControlLabel>
                  <FormControl
                    type="text"
                    name={messages.location}
                    placeholder={messages.location}
                    value={this.state.location}
                    onChange={this.handleLocationChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>{messages.date}</ControlLabel>
                  <DatePicker
                    className="form-control"
                    id="dateTimePicker"
                    onChange={this.handleDateChange.bind(this)}
                    selected={this.state.dateMoment}
                    name={messages.date}
                    placeholder={messages.date}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>{messages.time}</ControlLabel>
                  <br></br>
                  <TimeInput
                    message={messages.time}
                    time={this.state.dateTime}
                    onRequestChangeTime={this.handleTimeChange.bind(this)}
                  ></TimeInput>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <ControlLabel>{messages.notes}</ControlLabel>
                  <FormControl
                    componentClass="textarea"
                    name={messages.notes}
                    placeholder={messages.notes}
                    value={this.state.details}
                    onChange={this.handleNotesChange}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <GradientButton
              gradient="0/1"
              handleClick={this.props.onModalClose}
              title="Cancel"
            />
            <button type="submit" style={{ padding: 0, border: "none" }}>
              <GradientButton
                gradient="1/1"
                handleClick={this.handleUpdateEvent}
                title={messages.update}
              />
            </button>
          </Modal.Footer>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/timeline-event-form-update/TimelineEventFormUpdate.js